import React, { useState } from "react";
import GenericCard from "../../ui-components/Card/GenericCard";
import { ReactComponent as Info } from "../../shared/assets/Icons/circle-info-solid.svg";

/**
 * Playground for testing different card configurations.
 */
const CardPlayground: React.FC<{ theme: "light" | "dark" }> = ({theme}) => {
  const [variant, setVariant] = useState<"primary" | "secondary" | "tertiary">("primary");
  const [shadow, setShadow] = useState<"flat" | "sm" | "md">("flat");
  const [hasBorder, setHasBorder] = useState<boolean>(true);
  const [selectedOption, setSelectedOption] = useState<string>("option1");

  const radioOptions = {
    options: [
      { value: "option1", label: "I will provide Cross Connect (XC)",icon:<Info className="w-4 h-4 text-semantic-text-brand" />},
      { value: "option2", label: "I need Cross Connect (XC) - $350/month", icon:<Info className="w-4 h-4 text-semantic-text-brand" /> },
      { value: "option3", label: "I need Last Mile - Price will be estimated", icon:<Info  className="w-4 h-4 text-semantic-text-brand"/> },
    ],
    defaultValue: selectedOption,
    onChange: (value: string) => setSelectedOption(value),
  };

  return (
    <section className="mb-10">
      <h2 className="text-2xl font-semibold mb-6">Card Playground</h2>

      {/* Select Card Variant */}
      <div className="flex items-center mb-4">
        <label className="mr-2 font-medium">Variant:</label>
        <select
          value={variant}
          onChange={(e) => setVariant(e.target.value as "primary" | "secondary" | "tertiary")}
          className="border rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="primary">Primary</option>
          <option value="secondary">Secondary</option>
          <option value="tertiary">Tertiary</option>
        </select>
      </div>

      {/* Select Shadow Option */}
      <div className="flex items-center mb-4">
        <label className="mr-2 font-medium">Shadow:</label>
        <select
          value={shadow}
          onChange={(e) => setShadow(e.target.value as "flat" | "sm" | "md")}
          className="border rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="flat">Flat</option>
          <option value="sm">Small</option>
          <option value="md">Medium</option>
        </select>
      </div>

      {/* Toggle Border */}
      <div className="flex items-center mb-4">
        <label className="mr-2 font-medium">Border:</label>
        <input
          type="checkbox"
          checked={hasBorder}
          onChange={(e) => setHasBorder(e.target.checked)}
          className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
      </div>

      {/* Card Preview */}
      <GenericCard
        isCollapsible={false}
        variant={variant}
        shadow={shadow}
        theme={theme}
        hasBorder={hasBorder}
        headerContent={<h3 className="font-bold">Dynamic Card Header</h3>}
        bodyContent={
          <div>
            <p>This is a dynamic card. Modify its properties using the controls above.</p>
          </div>
        }
        radioOptions={radioOptions}
      />
    </section>
  );
};

export default CardPlayground;
